<div class="range-slider-container">

    <div *ngIf="locale ==='ru-ru'" class="position-relative">

        <input class="range-slider-input-ru" type="number" min="0" pattern="[0-9]*" [(ngModel)]="range[0]"
            (keydown.enter)="onChanges(rangeSliderInput, range, $event)"
            (change)="onChanges(rangeSliderInput, range, $event)" name="val1" />
        <label *ngIf="rangeSliderInput.unitsOfMeasure"
            class="currency-symbol-ru">{{rangeSliderInput.unitsOfMeasure}}</label>
        <!---
      <label *ngIf="rangeSliderInput.unitsOfMeasure !== '$' || rangeSliderInput.unitsOfMeasure === '£'" class="range-slider-input-label-right">{{rangeSliderInput.unitsOfMeasure}}</label>
      --->
    </div>
    <div *ngIf="locale !== 'ru-ru'" class="position-relative">
        <label *ngIf="rangeSliderInput.unitsOfMeasure" class="currency-symbol">
            <p [innerHTML]="rangeSliderInput.unitsOfMeasure"></p>
        </label>
        <input class="range-slider-input" type="number" min="0" pattern="[0-9]*" [(ngModel)]="range[0]"
            (keydown.enter)="onChanges(rangeSliderInput, range, $event)"
            (change)="onChanges(rangeSliderInput, range, $event)" name="val1" />
        <!---
        <label *ngIf="rangeSliderInput.unitsOfMeasure !== '$' || rangeSliderInput.unitsOfMeasure === '£'" class="range-slider-input-label-right">{{rangeSliderInput.unitsOfMeasure}}</label>
        --->
    </div>
    <div *ngIf="locale ==='ru-ru'" class="position-relative">

        <input class="range-slider-input-ru" type="number" min="0" pattern="[0-9]*" [(ngModel)]="range[1]"
            (keydown.enter)="onChanges(rangeSliderInput, range, $event)"
            (change)="onChanges(rangeSliderInput, range, $event)" name="val1" />
        <label *ngIf="rangeSliderInput.unitsOfMeasure"
            class="currency-symbol-ru">{{rangeSliderInput.unitsOfMeasure}}</label>
        <!---
        <label *ngIf="rangeSliderInput.unitsOfMeasure !== '$' || rangeSliderInput.unitsOfMeasure === '£'" class="range-slider-input-label-right">{{rangeSliderInput.unitsOfMeasure}}</label>
        --->
    </div>


    <div *ngIf="locale !=='ru-ru'" class="position-relative">
        <label *ngIf="rangeSliderInput.unitsOfMeasure" class="currency-symbol">
            <p [innerHTML]="rangeSliderInput.unitsOfMeasure"></p>
        </label>
        <input class="range-slider-input" type="number" min="0" pattern="[0-9]*" [(ngModel)]="range[1]"
            (keydown.enter)="onChanges(rangeSliderInput, range, $event)"
            (change)="onChanges(rangeSliderInput, range, $event)" name="val2" />
        <!---
        <label *ngIf="rangeSliderInput.unitsOfMeasure !== '$' || rangeSliderInput.unitsOfMeasure === '£'" class="range-slider-input-label-right">{{rangeSliderInput.unitsOfMeasure}}</label>
        --->
    </div>
</div>
<div class="nouislider-container" *ngIf="screenWidth !== 'SM'">
    <nouislider [connect]="true" [step]="1" [min]="rangeSliderInput.defaultMinRangeVal"
        [max]="rangeSliderInput.defaultMaxRangeVal" [(ngModel)]="range" name="name1-{{rangeSliderInput.minRangeVal}}"
        (keydown.enter)="onChanges(rangeSliderInput, range, $event)"
        (change)="onChanges(rangeSliderInput, range, $event)">
    </nouislider>
</div>